import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import "./styles.css";
import "./lib/error-capture";
import { router } from "./router";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error('Failed to find the root element with id "root"');

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <RouterProvider router={router} defaultPendingComponent={() => null} />
  </React.StrictMode>,
);
